import {
  ServiceDescriptorType,
  SERVICES,
} from '@rover/constants/src/translations/services.constants';

export function getServiceFromType(type: string | undefined): ServiceDescriptorType | undefined {
  return SERVICES().find((s) => s.type === type);
}
